import { mainFetch } from "../mainFetch"

const SERVICE_URL = '/shipment/ozon'

const fetchService = async ({ url, ...params }) =>
    await mainFetch({ url: SERVICE_URL + url, ...params })
        .catch(e => { console.log(e); throw (e) });

export default class PostingsOzonApi {

    static async getOrders({ data = { shop: undefined, status: undefined, saleSchema: undefined, isExpress: undefined, skladName: undefined }, ...params }) {
        return await fetchService({ url: '/getorders', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async shipOrders({ data = { shop: undefined, orders: undefined, orderId: undefined, shipmentId: undefined }, ...params }) {
        return await fetchService({ url: '/collectorders', method: 'POST', data, ...params })
    }



    static async loadFboPostings({ data = { shop: undefined, period: undefined, status: undefined }, ...params }) {
        return await fetchService({ url: '/loadpostingsfbo', method: 'POST', data, ...params })
    }

    // static async loadAllFbsPostings({ data = { shop: undefined, period: undefined, status: undefined }, ...params }) {
    //     return await fetchService({ url: '/loadpostingsfbs', method: 'POST', data, ...params })
    // }




    // static async shipOrdersPackages({ data = { shop: undefined, order: undefined, maxQuantity: undefined }, ...params }) {
    //     return await fetchService({ url: '/collectorderpackages', method: 'POST', data, ...params })
    // }




    static async cancelPostings({ data = { postingsNumbers: undefined }, ...params }) {
        return await fetchService({ url: '/cancelpostings', method: 'POST', data, ...params })
    }

    // static async toDelivery({ data = { postings: undefined }, ...params }) {
    //     return await fetchService({ url: '/todelivery', method: 'POST', data, ...params })
    // }




    static async updateFinances({ data = { shop: undefined, shipmentId: undefined }, ...params }) {
        return await fetchService({ url: '/updatefinances', method: 'POST', data, ...params })
    }

    static async loadReturns({ data = { shop: undefined }, ...params }) {
        return await fetchService({ url: '/loadreturns', method: 'POST', data, ...params })
    }
}